import React, { useState } from 'react'
import { Compass, Ship, ArrowRight, MessageSquare } from 'lucide-react';
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import { Sun, Award, UserCheck, Wind, Users, } from 'lucide-react';
import {  Camera, ChevronRight, Heart } from "lucide-react";
import {  Film,  MapPin, Anchor, Star } from "lucide-react";
// import {    Sunset } from 'lucide-react';
import {    Shield } from 'lucide-react';

import FAQSection from '../Components/FAQSection';

const pycFaqs = [
  {
    question: "What types of private yachts can I book in Mumbai?",
    answer: "You can explore private yacht charter options in Mumbai across categories such as sail boats, compact yachts, mid size yachts, premium yachts and bigger sail yachts."
  },
  {
    question: "How do I choose the right yacht category?",
    answer: "The right yacht depends on your group size, occasion, comfort preference and the type of private sea experience you want. Indiaboats can help recommend the best option."
  },
  {
    question: "Are sail boats and yachts both available for private charter?",
    answer: "Yes. Indiaboats offers both sail boats and private yachts in Mumbai for guests looking for different styles of on-water experience."
  },
  {
    question: "Is a compact yacht suitable for couples and small families?",
    answer: "Yes. Compact yachts are ideal for couples, small families and close groups looking for a private and comfortable yacht experience."
  },
  {
    question: "What is the benefit of choosing a premium yacht?",
    answer: "Premium yachts offer more space, stronger comfort, better onboard experience and a more elevated private yacht charter feel."
  },
  {
    question: "Can I book a private yacht for a birthday or anniversary?",
    answer: "Yes. Private yacht charters in Mumbai are a popular choice for birthdays, anniversaries and intimate celebrations."
  },
  {
    question: "Is a private yacht charter in Mumbai safe?",
    answer: "Yes. Indiaboats places strong emphasis on trained crew, guest support and responsible operations."
  },
  {
    question: "How do I enquire for a private yacht charter in Mumbai?",
    answer: "You can contact Indiaboats through the enquiry form or WhatsApp with your date, guest count and occasion."
  }
];


const PrivateYachtCharters = () => {
    // Active filter state
  const [selectedYachtCategory, setSelectedYachtCategory] = useState('All');

  // Unique variable name holding the curated private yacht options
  const privateYachtInventory = [
    {
      id: "yacht-01",
      title: "Classic Windward Sailer",
      category: "Sail Boats",
      size: "Authentic sailing feel",
      capacity: "Up to 6 Guests",
      desc: "Elegant private sailing experiences for guests who enjoy open-water charm, relaxed cruising and a more authentic sailing feel.",
      imgUrl: "https://images.unsplash.com/photo-1505044157772-6ae174669140?auto=format&fit=crop&q=80&w=600"
    },
    {
      id: "yacht-02",
      title: "Sunset Harborside Cruiser",
      category: "Compact Yachts",
      size: "Compact day cruiser",
      capacity: "Up to 8 Guests",
      desc: "Ideal for couples, small families and close groups looking for a private yacht rental in Mumbai with comfort and ease.",
      imgUrl: "https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?auto=format&fit=crop&q=80&w=600"
    },
    {
      id: "yacht-03",
      title: "Versatile Family Outing Yacht",
      category: "Mid Size Yachts",
      size: "Spacious versatile platform",
      capacity: "Up to 12 Guests",
      desc: "A balanced option offering more space, comfort and versatility for private outings, family leisure and special moments.",
      imgUrl: "https://images.unsplash.com/photo-1540962351504-03099e0a754b?auto=format&fit=crop&q=80&w=600"
    },
    {
      id: "yacht-04",
      title: "Premium Private Yacht Cruise",
      category: "Premium Yachts",
      size: "Luxury leisure experience",
      capacity: "Up to 15 Guests",
      desc: "A premium private yacht charter in Mumbai for guests looking for a more luxurious, spacious and exclusive sea experience.",
      imgUrl: "https://images.unsplash.com/photo-1567899378494-47b22a28c6ad?auto=format&fit=crop&q=80&w=600"
    },
    {
      id: "yacht-05",
      title: "Grand Horizon Sailing Vessel",
      category: "Bigger Sail Yachts",
      size: "Premium ocean-going sailer",
      capacity: "Up to 20 Guests",
      desc: "A distinctive sailing experience with more space and stronger premium appeal for memorable private charters on the water.",
      imgUrl: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&q=80&w=600"
    }
  ];

  // Dynamically extract unique categories for filter tabs
  const filterTabsList = ['All', 'Sail Boats', 'Compact Yachts', 'Mid Size Yachts', 'Premium Yachts', 'Bigger Sail Yachts'];

  // Filter logic based on tab state
  const filteredYachtsList = selectedYachtCategory === 'All' 
    ? privateYachtInventory 
    : privateYachtInventory.filter(yacht => yacht.category === selectedYachtCategory);


     // Active state to track the highlighted category
  const [activeCategoryIndex, setActiveCategoryIndex] = useState(0);

  // Unique variable name for the updated explore categories data
  const exploreYachtSegments = [
    {
      id: "01",
      title: "Classic Windward Sailer",
      category: "Sail Boats",
      size: "Authentic sailing feel",
      capacity: "Up to 6 Guests",
      desc: "Elegant private sailing experiences for guests who enjoy open-water charm, relaxed cruising and a more authentic sailing feel.",
      imgUrl: "https://images.unsplash.com/photo-1505044157772-6ae174669140?auto=format&fit=crop&q=80&w=1000",
      icon: <Wind size={20} />,
      amenities: ["Classic Rigging", "Open Deck Lounge", "Authentic Sea Breeze"]
    },
    {
      id: "02",
      title: "Sunset Harborside Cruiser",
      category: "Compact Yachts",
      size: "Compact day cruiser",
      capacity: "Up to 8 Guests",
      desc: "Ideal for couples, small families and close groups looking for a private yacht rental in Mumbai with comfort and ease.",
      imgUrl: "https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?auto=format&fit=crop&q=80&w=1000",
      icon: <Ship size={20} />,
      amenities: ["Sunset Saloon", "Couples Daybed", "Express Cruising"]
    },
    {
      id: "03",
      title: "Luxury Family Yacht Experience",
      category: "Mid Size Yachts",
      size: "Spacious and comfortable private format",
      capacity: "Up to 12 Guests",
      desc: "A mid size yacht rental in Mumbai designed for family outings, private leisure and premium moments on the water.",
      imgUrl: "https://images.unsplash.com/photo-1540962351504-03099e0a754b?auto=format&fit=crop&q=80&w=1000",
      icon: <Users size={20} />,
      amenities: ["Spacious Flybridge", "Multi-zone Audio", "Leisure Swim Platform"]
    },
    {
      id: "04",
      title: "Premium Private Yacht Cruise",
      category: "Premium Yachts",
      size: "Luxury leisure experience",
      capacity: "Up to 15 Guests",
      desc: "A premium private yacht charter in Mumbai for guests looking for a more luxurious, spacious and exclusive sea experience.",
      imgUrl: "https://images.unsplash.com/photo-1567899378494-47b22a28c6ad?auto=format&fit=crop&q=80&w=1000",
      icon: <Award size={20} />,
      amenities: ["Master Suite Cabin", "Gourmet Galley", "Exclusive Crew Service"]
    },
    {
      id: "05",
      title: "Grand Horizon Sailing Vessel",
      category: "Bigger Sail Yachts",
      size: "Premium ocean-going sailer",
      capacity: "Up to 20 Guests",
      desc: "A distinctive sailing experience with more space and stronger premium appeal for memorable private charters on the water.",
      imgUrl: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&q=80&w=1000",
      icon: <Compass size={20} />,
      amenities: ["Expansive Teak Decks", "High-performance Rigging", "Grand Dining Lounge"]
    }
  ];


const premiumYachtCategories = [
    {
      id: "01",
      title: "Classic Windward Sailer",
      category: "Sail Boats",
      size: "Authentic sailing feel",
      capacity: "Up to 6 Guests",
      desc: "Elegant private sailing experiences for guests who enjoy open-water charm, relaxed cruising and a more authentic sailing feel.",
      imgUrl: "https://images.unsplash.com/photo-1505044157772-6ae174669140?auto=format&fit=crop&q=80&w=600",
      type: "Authentic Experience"
    },
    {
      id: "02",
      title: "Sunset Private Yacht Charter",
      category: "Compact Yachts",
      size: "Ideal for intimate premium experiences",
      capacity: "Up to 10 Guests",
      desc: "A compact private yacht charter in Mumbai ideal for couples, families and small groups looking for comfort, privacy and a memorable sea experience.",
      imgUrl: "https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?auto=format&fit=crop&q=80&w=600",
      type: "Intimate Cruise"
    },
    {
      id: "03",
      title: "Luxury Family Yacht Experience",
      category: "Mid Size Yachts",
      size: "Spacious and comfortable private format",
      capacity: "Up to 12 Guests",
      desc: "A mid size yacht rental in Mumbai designed for family outings, private leisure and premium moments on the water.",
      imgUrl: "https://images.unsplash.com/photo-1540962351504-03099e0a754b?auto=format&fit=crop&q=80&w=600",
      type: "Versatile Comfort"
    },
    {
      id: "04",
      title: "Premium Private Yacht Cruise",
      category: "Premium Yachts",
      size: "Luxury leisure experience",
      capacity: "Up to 15 Guests",
      desc: "A premium private yacht charter in Mumbai for guests looking for a more luxurious, spacious and exclusive sea experience.",
      imgUrl: "https://images.unsplash.com/photo-1567899378494-47b22a28c6ad?auto=format&fit=crop&q=80&w=600",
      type: "Signature Luxury"
    },
    {
      id: "05",
      title: "Grand Horizon Sailing Vessel",
      category: "Bigger Sail Yachts",
      size: "Premium ocean-going sailer",
      capacity: "Up to 20 Guests",
      desc: "A distinctive sailing experience with more space and stronger premium appeal for memorable private charters on the water.",
      imgUrl: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&q=80&w=600",
      type: "Grand Voyage"
    }
  ];

  
  return (
    <>
        <Header/>

          <div className="ib-page-wrapper">
             <div className="aeb-page-section-one">
      {/* 1. HERO HEADER */}
      <section className="aeb-hero">
        <div className="aeb-container">
          <div className="aeb-hero-grid">
            
            {/* Text Column */}
            <div className="aeb-hero-content">
              
              <h1 className="aeb-hero-title">
               Private Yacht Charters in Mumbai
              </h1>
              <p className="aeb-hero-subtext">
               Explore private yacht charters in Mumbai with Indiaboats. Browse sail boats, compact yachts, mid size yachts, premium yachts and bigger sail yachts for couples, families and small groups seeking a premium experience on the water.
              </p>
              
              <div className="aeb-hero-btn-stack">
                <a href="#plan" className="th-btn style3 th-icon">
                  Book a Private Yacht
                  <ArrowRight size={16} />
                </a>
                <a href="https://wa.me/917977600563" className="aeb-btn aeb-btn-whatsapp" target="_blank" rel="noopener noreferrer">
                  <MessageSquare size={16} fill="currentColor" />
                  Enquire on WhatsApp
                </a>
                <a href="#options" className="aeb-btn aeb-btn-secondary">
                 Request a Quote
                </a>
              </div>
            </div>

            {/* Visual Column */}
            <div className="aeb-hero-media">
              <div className="aeb-image-frame">
                <img 
                  src="https://images.unsplash.com/photo-1562281302-809108fd533c?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" 
                  alt="Premium Yacht sailing away from Gateway of India, Mumbai" 
                  className="aeb-media-img" 
                />
                <div className="aeb-floating-card">
                  <Ship size={20} className="aeb-floating-icon" />
                  <div>
                    <span className="aeb-floating-title">Premium Fleet Only</span>
                    <span className="aeb-floating-desc">Catering to comfort & style</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* 2. TRUST STRIP */}
   <div className="aeb-trust-strip">
  <div className="aeb-container">
    <div className="aeb-trust-flex">

      <span className="aeb-trust-item">
        Private Yacht Charter Mumbai
      </span>
      <span className="aeb-trust-divider">|</span>

      <span className="aeb-trust-item">
        Luxury Yacht Rental
      </span>
      <span className="aeb-trust-divider">|</span>

      <span className="aeb-trust-item">
        Trained Crew
      </span>
      <span className="aeb-trust-divider">|</span>

      <span className="aeb-trust-item">
        Family Outings
      </span>
      <span className="aeb-trust-divider">|</span>

      <span className="aeb-trust-item">
        Premium Sea Experiences
      </span>

    </div>
  </div>
</div>

    <section className="lyc-main-section">
      <div className="lyc-container">
        
        {/* Top Header - Sized & Colored Perfectly */}
        <div className="lyc-header-block">
          <div className="lyc-tag-row">
            <Anchor size={12} className="lyc-anchor-icon" />
            <span className="lyc-pre-title">Luxury Fleet</span>
          </div>
          
          <h2 className="lyc-section-title">
            Luxury <br />
            <span className="lyc-light-text">Transfers & Charters</span>
          </h2>
          
          <p className="lyc-section-subtitle">
            Browse private yacht charter options in Mumbai by yacht category and experience style. 
            These category cards are designed to be dynamically pulled from the backend database.
          </p>
          
          <div className="lyc-title-divider"></div>
        </div>

        {/* Dynamic 5-Card Grid Layout */}
        <div className="lyc-cards-grid">
          {premiumYachtCategories.map((category, index) => (
            <div key={index} className="lyc-card">
              <div className="lyc-card-top-accent"></div>
              
              {/* Media Frame with Hover Effect */}
              <div className="lyc-image-wrapper">
                <img 
                  src={category.imgUrl} 
                  alt={category.title} 
                  className="lyc-card-img" 
                />
                <div className="lyc-img-overlay"></div>
                <div className="lyc-badge">
                  <Star size={10} className="lyc-star-icon" />
                  <span>{category.category}</span>
                </div>
              </div>

              {/* Text Area */}
              <div className="lyc-card-content">
                <div className="lyc-card-header">
                  <span className="lyc-card-num">{category.id}</span>
                  <h3 className="lyc-card-title">{category.title}</h3>
                </div>

                {/* Specific Specs Details Block (Size & Capacity) */}
                <div className="lyc-card-specs">
                  <div className="lyc-spec-row">
                    <Compass size={12} className="lyc-spec-icon" />
                    <span>{category.size}</span>
                  </div>
                  <div className="lyc-spec-row">
                    <Users size={12} className="lyc-spec-icon" />
                    <span>{category.capacity}</span>
                  </div>
                </div>
                
                <p className="lyc-card-desc">{category.desc}</p>
                
                <div className="lyc-card-footer">
                  <button className="lyc-card-cta">
                    <span>Explore Yacht</span>
                    <ChevronRight size={14} className="lyc-arrow-icon" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
      </section>
     
      </div>

 <section className="lyc-explore-section">
      <div className="lyc-explore-container">
        
        {/* Header Block Sized Elegantly */}
        <div className="lyc-explore-header">
          <div className="lyc-explore-badge-row">
            <Anchor size={14} className="lyc-explore-badge-icon" />
            <span className="lyc-explore-pre-title">Yacht Categories</span>
          </div>
          <h2 className="lyc-explore-main-title">
            Explore <span className="lyc-explore-light-text">Yacht Segments</span>
          </h2>
          <p className="lyc-explore-subtitle">
            Select your preferred yacht category to explore available private yacht charter options in Mumbai by size, style and guest capacity.
          </p>
        </div>

        {/* Master-Detail Split Container */}
        <div className="lyc-explore-split-layout">
          
          {/* Master Panel: Navigation Items List */}
          <div className="lyc-explore-navigation">
            {exploreYachtSegments.map((segment, index) => {
              const isSelected = activeCategoryIndex === index;
              return (
                <button
                  key={segment.id}
                  className={`lyc-nav-item-btn ${isSelected ? 'active' : ''}`}
                  onClick={() => setActiveCategoryIndex(index)}
                  onMouseEnter={() => setActiveCategoryIndex(index)}
                >
                  <div className="lyc-nav-item-inner">
                    <span className="lyc-nav-num">{segment.id}</span>
                    <div className="lyc-nav-text-block">
                      <h3 className="lyc-nav-title">{segment.category}</h3>
                    </div>
                  </div>
                  <ChevronRight size={18} className="lyc-nav-arrow" />
                </button>
              );
            })}
          </div>

          {/* Detail Panel: Dynamic Immersive Spotlight */}
          <div className="lyc-explore-spotlight">
            <div className="lyc-spotlight-visual-frame">
              <img 
                src={exploreYachtSegments[activeCategoryIndex].imgUrl} 
                alt={exploreYachtSegments[activeCategoryIndex].title} 
                className="lyc-spotlight-bg-img" 
              />
              <div className="lyc-spotlight-gradient-overlay"></div>
              
              {/* Overlay Content */}
              <div className="lyc-spotlight-details">
                <div className="lyc-spotlight-meta-row">
                  <div className="lyc-spotlight-icon-box">
                    {exploreYachtSegments[activeCategoryIndex].icon}
                  </div>
                  <span className="lyc-spotlight-category-tag">
                    {exploreYachtSegments[activeCategoryIndex].category}
                  </span>
                </div>
                
                {/* Specific Title mapping */}
                <h4 className="lyc-spotlight-category-title">
                  {exploreYachtSegments[activeCategoryIndex].title}
                </h4>

                {/* Specific Specs Row (Size and Capacity) */}
                <div className="lyc-spotlight-specs">
                  <span className="lyc-spec-pill">
                    <strong>Format:</strong> {exploreYachtSegments[activeCategoryIndex].size}
                  </span>
                  <span className="lyc-spec-pill">
                    <strong>Capacity:</strong> {exploreYachtSegments[activeCategoryIndex].capacity}
                  </span>
                </div>
                
                {/* Specific Short Description mapping */}
                <p className="lyc-spotlight-desc">
                  {exploreYachtSegments[activeCategoryIndex].desc}
                </p>

                {/* Scoped list of custom category attributes */}
                <div className="lyc-spotlight-amenities">
                  {exploreYachtSegments[activeCategoryIndex].amenities.map((amenity, key) => (
                    <div key={key} className="lyc-amenity-tag">
                      <Shield size={12} className="lyc-tag-check" />
                      <span>{amenity}</span>
                    </div>
                  ))}
                </div>

                {/* Specific Button mapping */}
                <div className="lyc-spotlight-action-row">
                  <button className="lyc-spotlight-cta-btn">
                    <span>Explore Yacht</span>
                    <ChevronRight size={14} />
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
      </section>

       

     <section className="epyo-main-section">
      <div className="epyo-container">
        
        {/* Section Header */}
        <header className="epyo-header-block">
          <div className="epyo-badge-row">
            <Anchor size={14} className="epyo-badge-icon" />
            <span className="epyo-pre-title">Exclusive Charters</span>
          </div>
          
          <h2 className="epyo-section-title">
            Explore <span className="epyo-light-text">Private Yacht Options</span>
          </h2>
          
          <p className="epyo-section-subtitle">
            Find the right private yacht charter in Mumbai based on yacht category, guest capacity and preferred experience.
          </p>
          
          <div className="epyo-title-divider"></div>
        </header>

        {/* Categories Filtering Navigation */}
        <div className="epyo-filter-navigation">
          {filterTabsList.map((categoryTab, tabIndex) => (
            <button
              key={tabIndex}
              className={`epyo-filter-tab-btn ${selectedYachtCategory === categoryTab ? 'active' : ''}`}
              onClick={() => setSelectedYachtCategory(categoryTab)}
            >
              {categoryTab}
            </button>
          ))}
        </div>

        {/* Dynamic Cards Grid */}
        <div className="epyo-catalog-grid">
          {filteredYachtsList.map((yachtItem) => (
            <div key={yachtItem.id} className="epyo-catalog-card">
              <div className="epyo-card-accent-line"></div>
              
              {/* Card Media Wrapper */}
              <div className="epyo-card-image-frame">
                <img src={yachtItem.imgUrl} alt={yachtItem.title} className="epyo-card-img" />
                <div className="epyo-image-overlay"></div>
                <span className="epyo-category-badge">{yachtItem.category}</span>
              </div>

              {/* Card Body Information */}
              <div className="epyo-card-body">
                <h3 className="epyo-card-title">{yachtItem.title}</h3>
                
                {/* Yacht Key Metrics Row */}
                <div className="epyo-metrics-row">
                  <div className="epyo-metric-item">
                    <Compass size={14} className="epyo-metric-icon" />
                    <span className="epyo-metric-text">{yachtItem.size}</span>
                  </div>
                  <div className="epyo-metric-item">
                    <Users size={14} className="epyo-metric-icon" />
                    <span className="epyo-metric-text">{yachtItem.capacity}</span>
                  </div>
                </div>

                <p className="epyo-card-desc">{yachtItem.desc}</p>
                
                {/* Action Footer */}
                <div className="epyo-card-footer">
                  <button className="epyo-card-cta-btn">
                    <span>Explore Yacht</span>
                    <div className="epyo-cta-arrow-box">
                      <ArrowRight size={14} />
                    </div>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
      </section>

  

    <section className="ib-luxury-feature-wrapper">
  <div className="ib-luxury-feature-container">
    <div className="ib-luxury-feature-main-content">
      <h2 className="ib-luxury-feature-headline">
        Why Choose Indiaboats for Private Yacht Charters
      </h2>
      <p>
        <span className="ib-luxury-feature-text-accent">Indiaboats</span> 
        offers private yacht charters in Mumbai across multiple yacht categories, making it easier for guests to choose the right experience based on comfort, style, group size and occasion. Whether you prefer a classic sail boat, a compact yacht for a couple outing, a mid size yacht for family time or a premium yacht for a more luxurious experience, our fleet is designed to suit different private charter needs.
      </p>
      <p>
        We help guests explore the right yacht category and booking format so each private yacht experience feels comfortable, well-managed and memorable.
      </p>
    </div>

    <div className="ib-luxury-feature-grid">
      {[
        { title: "Diverse Fleet", desc: "Private yacht charter options across multiple yacht categories", icon: <Ship size={24} /> },
        { title: "Tailored Options", desc: "Sail boats, compact yachts, mid size yachts and premium yachts", icon: <Anchor size={24} /> },
        { title: "Versatile Groups", desc: "Ideal for couples, families and small private groups", icon: <Users size={24} /> },
        { title: "Perfect Moments", desc: "Suitable for leisure, sunset outings and special moments", icon: <Sun size={24} /> },
        { title: "Expert Crew", desc: "Trained crew and service-first experience", icon: <UserCheck size={24} /> },
        { title: "Premium Quality", desc: "Premium private yacht rental in Mumbai", icon: <Star size={24} /> }
      ].map((item, index) => (
        <div key={index} className="ib-luxury-feature-card">
          <div className="ib-luxury-feature-icon-box">{item.icon}</div>
          <div className="ib-luxury-feature-card-content">
            <h4>{item.title}</h4>
            <p>{item.desc}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

      

  <section className="pfUniqueMainSection">
  <div className="pfUniqueContainer">
    
    {/* Section Header */}
    <div className="pfUniqueHeader" style={{ marginBottom: '2rem' }}>
      <h2 className="pfUniqueHeading">
        Perfect For
      </h2>
    </div>

    {/* Main Content Grid */}
    <div className="pfUniqueGridWrapper">
      {[
        "Private yacht charter in Mumbai for couples",
        "Family private yacht outings",
        "Small group private cruises",
        "Sunset yacht experiences",
        "Premium private sea outings",
        "Birthday and anniversary celebrations",
        "Romantic and leisure yacht experiences"
      ].map((item, index) => (
        <div className="pfUniqueCardBox" key={index}>
          <div className="pfUniqueCheckIcon">✓</div>
          <p className="pfUniqueCardText">{item}</p>
        </div>
      ))}
    </div>
  </div>
</section>



      

   <section className="wteUniqueMainSection">
  <div className="wteUniqueContainer">
    <div className="wteUniqueContentWrapper">
      <div className="wteUniqueLeftContent">
        <span className="wteUniqueMiniTitle">
          WHAT TO EXPECT
        </span>

        <h2 className="wteUniqueHeading">
          What to Expect with <span>Indiaboats</span>
        </h2>

        <p className="wteUniqueParagraph">
          Every private yacht charter in Mumbai can be chosen based on yacht category, group size and preferred experience. Whether you select a sail boat, compact yacht, mid size yacht, premium yacht or bigger sail yacht, Indiaboats helps you find an option that matches your comfort level, occasion and desired experience on the water.
        </p>
      </div>

      <div className="wteUniqueRightContent">
        {[
          "Private yacht charter",
          "Category-based yacht selection",
          "Professional crew",
          "Scenic sea experience",
          "Comfortable private setting",
          "Suitable for couples, families and close groups",
          "Booking assistance and coordination",
          "Safety briefing and support"
        ].map((item, index) => (
          <div className="wteUniqueListCard" key={index}>
            <div className="wteUniqueCheckCircle">✓</div>
            <p className="wteUniqueListText">{item}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
</section>

     <section className="scUniqueMainSection">
      <div className="scUniqueContainer">
        <div className="scUniqueContentBox">
          <span className="scUniqueMiniTitle">
            SAFETY & COMFORT
          </span>

          <h2 className="scUniqueHeading">
            Safety, Comfort and <span>Service</span>
          </h2>

          <p className="scUniqueParagraph">
          At Indiaboats, safety is central to every private yacht charter experience. We place strong emphasis on trained crew, responsible operations, guest comfort and smooth coordination so every private yacht rental in Mumbai is both enjoyable and professionally managed.
          </p>
        </div>
      </div>
    </section>

    <FAQSection
  pageKey="private-yacht-charters"
  title="Frequently Asked Questions About Private Yacht Charters"
  faqData={pycFaqs}
/>

 <section className="igxMainCtaSection">
      <div className="igxMainCtaContainer">
        <div className="igxGlassCardWrapper">

        

          <h2 className="igxMainHeading">
           Book Your <span>Private Yacht Charter</span> in Mumbai
          </h2>

          <p className="igxParagraphText">
           Browse sail boats, compact yachts, mid size yachts, premium yachts and bigger sail yachts to find the right private yacht charter in Mumbai for your next outing.
          </p>

          <div className="igxButtonFlex">

            <button className="igxPrimaryActionBtn">
              <span>Book a Private Yacht </span>
            </button>

            <button className="igxOutlineActionBtn">
              <span>Explore Private Yacht Charters</span>
            </button>

            <button className="igxWhatsappActionBtn">
              <span>Request a Quote</span>
            </button>

          </div>
        </div>
      </div>
    </section>

     <section className="btfUniqueSection">
      <div className="btfUniqueContainer">

        <div className="btfUniqueFormCard">

          <div className="btfUniqueTopContent">
            <h2 className="btfUniqueHeading">
              Tell Us What You’re <span>Planning</span>
             
            </h2>

            <p className="btfUniqueParagraph">
              Share your preferred destination, group size and travel
              requirement and our team will help you plan the right
              private boat experience.
            </p>
          </div>

       <form className="btfUniqueFormWrapper">
  <div className="btfUniqueInputGrid">
    
    <div className="btfUniqueFieldBox">
      <label>Name</label>
      <input type="text" placeholder="Enter your name" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Mobile Number</label>
      <input type="tel" placeholder="Enter mobile number" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Email Address</label>
      <input type="email" placeholder="Enter email address" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Preferred Date</label>
      <input type="date" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Number of Guests</label>
      <input type="number" placeholder="Number of guests" />
    </div>

  <div className="btfUniqueFieldBox">
  <label>Occasion</label>
  <input type="text" placeholder="e.g. Birthday, Anniversary, Private Celebration" />
</div>

<div className="btfUniqueFieldBox">
  <label>Preferred Yacht Category</label>
  <select>
    <option value="">Select yacht category</option>
    <option value="sail-boat">Sail Boat</option>
    <option value="compact-yacht">Compact Yacht</option>
    <option value="mid-size-yacht">Mid-Size Yacht</option>
    <option value="premium-yacht">Premium Yacht</option>
    <option value="large-sail-yacht">Bigger Sail Yacht</option>
  </select>
</div>

  </div>

  <div className="btfUniqueFieldBox btfUniqueTextareaBox">
    <label>Requirement Details</label>
    <textarea
      rows="6"
      placeholder="Tell us more about your private party requirements..."
    ></textarea>
  </div>

  <button
    type="submit"
    className="btfUniqueSubmitButton"
  >
    <span>Request a Quote</span>
  </button>
</form>
        </div>
      </div>
    </section>

            </div>


<Footer/>
</>
  )
}

export default PrivateYachtCharters
